// extracted by mini-css-extract-plugin
export default {"block":"AddTransactionParties_block__JrLKK","title":"AddTransactionParties_title__Yivtz","usedRoles":"AddTransactionParties_usedRoles__nA2rB"};